import React, { useState } from "react";
import { toast } from "react-toastify";
import { addLeague } from "../../services/leagueService";
import { useNavigate } from "react-router-dom";

export const AddLeagueLayer = () => {
  const [leagueName, setLeagueName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // ✅ ADD

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!leagueName.trim()) {
      toast.error("League name is required");
      return;
    }

    setLoading(true);
    try {
      const res = await addLeague(leagueName);

      if (res?.status === true) {
        toast.success("League added successfully");

        // ✅ NAVIGATE TO LEAGUE LIST
        navigate("/league-list");
      } else {
        toast.error(res?.message || "Failed to add league");
      }
    } catch {
      toast.error("Something went wrong");
    }
    setLoading(false);
  };

  return (
    <div className="container-fluid mt-4">
      <div className="row justify-content-center">
        <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
          <div className="card">
            <div className="card-body">
              <h5>Add League</h5>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="League Name"
                  value={leagueName}
                  onChange={(e) => setLeagueName(e.target.value)}
                />

                <button
                  className="btn btn-primary w-100"
                  disabled={loading}
                >
                  {loading ? "Please wait..." : "Add League"}
                </button>
              </form>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
